import { Box, Link, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumb } from '../../components/layout/Breadcrumb';
import { ROUTES } from '../../constants/routes';

interface ProjectTabNavProps {
  projectId: string;
  projectName: string;
  activeTab: 'locations' | 'workorders' | 'tests';
}

export const ProjectTabNav = ({ projectId, projectName, activeTab }: ProjectTabNavProps) => {
  const theme = useTheme();
  const locationsPath = ROUTES.LOCATIONS.replace(':projectId', projectId);
  const workOrdersPath = ROUTES.WORK_ORDERS.replace(':projectId', projectId);
  const testsPath = `/projects/${projectId}/tests`;

  const tabStyle = (isActive: boolean) => ({
    px: 2,
    py: 0.5,
    fontSize: '0.8125rem',
    fontWeight: isActive ? 600 : 500,
    backgroundColor: isActive ? theme.palette.primary.main : undefined,
    color: isActive ? '#fff' : 'text.primary',
    display: 'block',
    '&:hover': isActive ? {} : { backgroundColor: theme.table.hoverBg },
  });

  const breadcrumbs = [
    { label: 'Projects', path: ROUTES.PROJECTS, entityType: 'project' as const },
    { label: projectName, entityType: 'project' as const },
  ];

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Breadcrumb items={breadcrumbs} />
        <Paper
          variant="outlined"
          sx={{
            display: 'inline-flex',
            borderColor: theme.border.color,
            borderRadius: `${theme.border.radius}px`,
            overflow: 'hidden',
            ml: 1,
          }}
        >
          <Link component={RouterLink} to={locationsPath} underline="none" sx={tabStyle(activeTab === 'locations')}>
            Locations &amp; Samples
          </Link>
          <Link component={RouterLink} to={workOrdersPath} underline="none" sx={tabStyle(activeTab === 'workorders')}>
            Work Orders
          </Link>
          <Link component={RouterLink} to={testsPath} underline="none" sx={tabStyle(activeTab === 'tests')}>
            Tests
          </Link>
        </Paper>
      </Box>
    </Box>
  );
};
